const autoNgTemplateLoaderTemplate1 = require('./volumesDatatable.html');

angular.module('shbdeployer.docker').component('volumesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'VolumesDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    showHostColumn: '<',
    removeAction: '<',
    showBrowseAction: '<',
    offlineMode: '<',
    refreshCallback: '<',
  },
});
